import AxiosAPI from "./AxiosAPI";
export const getKOTRunningNo = async (cashRegisterID) => {
  try {
    
    const response = await AxiosAPI.get(`/kotrunningno/${cashRegisterID}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveKOT = async (kot) => {
  try {
    
    const response = await AxiosAPI.post("/kot", kot);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateKOTStatus = async (key, status) => {
  try {
    const response = await AxiosAPI.put("/kot", {
    key: key,       // send the correct KOT doc key
      status: status,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getKOT = async (storeId,status) => {
  try {
    
    const response = await AxiosAPI.get("/kot",  {
        params: {
          storeID:storeId,
          status:status
        }
      });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTables = async (storeId) => {
  try {


    const response = await AxiosAPI.get(`/tables/${storeId}`);
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
// Add Table
export const handleAddTable = async (payload) => {
  try {
    const response = await AxiosAPI.post("/table", payload);
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

// Update Table
export const handleUpdateTable = async (payload, key) => {
  try {
    const response = await AxiosAPI.put(`/table/${key}`, payload);
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

// Delete Table
export const handleDeleteTable = async (key) => {
  try {
    const response = await AxiosAPI.delete(`/table/${key}`);
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};